
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[city]/[domain]",
      function () {
        return require("private-next-pages/store/[city]/[domain].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[city]/[domain]"])
      });
    }
  